import { WebhooksScreen } from '@features/webhooks'

export function WebhooksPage() {
  return <WebhooksScreen />
}
